import {VerifyHost} from './host'
// const HOST = 'http://watch.zxsmart.cn'
const HOST = ''
const API_URL = '/api'
function api_url (path) {
    return HOST + API_URL + path
}

function common_url (path) {
    return HOST + path
}

export default {
    api: {
        verify_image_url: VerifyHost,
        auth_url: common_url('/auth/v1.0/login'),
        menu_url: api_url('/menu/v1.0'),
        alarm: api_url('/alarms/v1.0/'),
        device_url: api_url('/device/v1.0'),
        device_types_url: api_url('/device/v1.0/models'),
        device_page_url: api_url('/device/v1.0/page'),
        device_overView_url: api_url('/device/v1.0/overView'),
        device_query_url: api_url('/device/v1.0/all'),
        device_store_url: api_url('/device/v1.0/store'),
        device_distribute_url: api_url('/device/v1.0/distribute'),
        device_store_upload_url: api_url('/device/v1.0/store/upload'),
        device_update_upload_url: api_url('/device/v1.0/update/upload'),
        device_update_org_url: api_url('/device/v1.0/org/modify'),
        entity_url: api_url('/entity/v1.0'),
        entity_delete_url: api_url('/entity/v1.0/delete/all'),
        entity_all_url: api_url('/entity/v1.0/queryAll'),
        entity_title_url: api_url('/entity/v1.0/titles'),
        entity_group_url: api_url('/entityGroup/v1.0'),
        entity_group_sa_url: api_url('/entityGroup/v1.0/sa'),
        entity_group_update_url: api_url('/entityGroup/v1.0/update'),
        entity_group_default_url: api_url('/entityGroup/v1.0/defaultGroup'),
        entity_bind_url: api_url('/entity/v1.0/bind/device'),
        entity_update_url: api_url('/entity/v1.0/update'),
        entity_group_summary_url: api_url('/entityGroup/v1.0/summary'),
        entity_group_statistic_url: api_url('/entityGroup/v1.0/statistic'),
        entity_upload_url: api_url('/entity/v1.0/upload'),
        entity_template_org_url: api_url('/entityTemplate/v1.0/org'),
        entity_template_url: api_url('/entityTemplate/v1.0'),
        entity_map_data_url: api_url('/entity/v1.0/map/data'),
        entity_command_url: api_url('/entity/v1.0/sendCommand/batch'),
        entity_absent_url: api_url('/entity/v1.0/absent'),
        org_url:api_url('/org/v1.0'),
        org_tree_url: api_url('/org/v1.0/tree'),
        org_tree_all_url: api_url('/org/v1.0/tree/all'),
        org_custom_url: api_url('/org/v1.0/customize'),
        org_address_url: api_url('/org/v1.0/address'),
        file_upload_url: api_url('/file/v1.0/upload'),
        rule_template_url: api_url('/ruleTemplate/v1.0'),
        rule_template_basic_url: api_url('/ruleTemplate/v1.0/base'),
        rule_template_regular_url: api_url('/ruleTemplate/v1.0/regular'),
        rule_template_fence_url: api_url('/ruleTemplate/v1.0/fence'),
        entity_unbind_url: api_url('/entity/v1.0/unbind/device'),
        entity_detail_url: api_url('/entity/v1.0/detail'),
        entity_health_data_url: api_url('/entity/v1.0/health'),
        entity_fence_url: api_url('/entity/v1.0/allFences'),
        general_data_url: api_url('/general/v1.0'),
        supervise_template_url: api_url('/ruleTemplate/v1.0'),
        users_url: api_url('/users/v1.0'),
        url_reset_password: api_url('/users/v1.0/password/reset'),
        user_update_url: api_url('/users/v1.0/user'),
        users_statistic_url: api_url('/users/v1.0/statistic/'),
        users_org_url: api_url('/users/v1.0/org/'),
        users_org_me_url: api_url('/users/v1.0/me'),
        alarm_process_url: api_url('/alarm/v1.0/process'),
        users_data_url: api_url('/users/v1.0'),
        alarm_url: api_url('/alarm/v1.0'),
        alarm_all_url: api_url('/alarm/v1.0/all'),
        alarm_entity_url: api_url('/alarm/v1.0/entity'),
        alarm_config_url: api_url('/alarm/v1.0/config'),
        alarm_number_url: api_url('/alarm/v1.0/number'),
        org_statistic_url: api_url('/org/v1.0/statistic/'),

        // 获取首页概览统计数据 post
        /**
         * method: POST
         * body参数
         * {
         *  region: '1' 省份的id （可选）
         *  orgLink: '20,' 用户即组织机构的link层级链 (可选)
         *  model: 设备类型ID （可选）
         * }
         *
         */
        home_device_overView_url: api_url('/home/v1.0/overView'),

        // 获取首页集成商以及设备等统计 get
        home_total_table_url: api_url('/home/v1.0/table'),

        /**
         * 获取设备类型 GET
         */
        get_device_models: api_url('/device/v1.0/models'),
        
        /**
         * 获取所有省份ID POST
         * 没有参数
         */
        get_all_province_id: api_url('/home/v1.0/region'),

        /**
         * 根据level指定的深度查询机构树
         * level: number
         * /org/v1.0/tree/:level
         * GET
         *  */
        query_orgtree_bylevel: api_url('/org/v1.0/tree/'),
        
        /**
         *  获取个人围栏的接口
         *  url参数 id
         *  /api/entity/v1.0/personalFence/${id}
         *  */ 
        get_personal_fence: api_url('/entity/v1.0/personalFence/'),

        /**
         *  获取场景树
         *  url参数 id
         *  /api/org/v1.0/scenes/tree/${id}
         *  */ 
        get_scenes_fence: api_url('/org/v1.0/scenes/tree/'),

        /**
         * 新增个人围栏的接口 POST
         * url 参数： id当前个体(人物)的id  /entity/v1.0/personalFence/:id
         * body参数： []
         *  */ 
        add_personnal_fence: api_url('/entity/v1.0/personalFence/'),

        /**
         * 修改个人围栏的接口 PUT
         * body参数： {}
         *  */ 
        put_personnal_fence: api_url('/entity/v1.0/personalFence'),

        /**
         * 删除个人围栏的接口 DELETE
         * url 参数： id当前围栏的id  /entity/v1.0/personalFence/:id
         *  */ 
        delete_personnal_fence: api_url('/entity/v1.0/personalFence/'),

         /**
         * 获取个人配置的接口 GET
         * url 参数： id当前个人的id  /entity/v1.0/personalConfig/:id
         *  */ 
        get_personnal_config: api_url('/entity/v1.0/personalConfig/'),

        /**
         * 
         * 删除某项个人配置 delete
         * url参数： /:id/:name
         * /entity/v1.0/personalConfig/:id/:name
         *  删除个人配置参数：entityId    实体IDconfigName    配置名称，多个用  ,  分割 
         *  */ 
        delete_personnal_config_by_name: api_url('/entity/v1.0/personalConfig/'),

        /**
         * 
         * 修改某项个人配置 put
         * body {"id": 44,
         *   "autoPowerUp": 79200,
         *   "autoPowerDown": 79200,
         *   "customLocate": [
         *   {
         *   "startTime": 7200,
         *   "endTime": 72000,
         *   "intervalTime": 1200
         *   }
         *   ]
         *   }
         *  */ 
        put_personnal_config: api_url('/entity/v1.0/personalConfig'),
        
        /**
         * 获取登录是否需要验证码 GET
         * /api/commons/v1.0/verifyCode   get     查询是否需要验证码
         * 返回 code === 0 不需要 10 需要
         *  */
        login_need_verify: api_url('/commons/v1.0/verifyCode'),


        /**
         * 获取验证码图片 GET
         * /api/commons/v1.0/verifyCode/image
         * 参数无
         *  */
        get_login_verify_image: api_url('/commons/v1.0/verifyCode/image'),


        /** 
         * /api/commons/v1.0/verifyCode/sms/{phoneNum}/{verifyCode}
         *  get    
         *  申请发送短信验证码
         *
         * */ 
        apply_send_phone_message: api_url('/commons/v1.0/verifyCode/sms/'),


        /**
         * /auth/v1.0/sms/login    post    短信登录
         *  传参：{"phoneNum":"18782236939","smsVerifyCode":"176781","              version":"ccccc""platform":"dddddddd"}
         *  */ 
        login_by_phone: common_url('/auth/v1.0/sms/login'),


        /**
         *  获取轨迹点
         * /api/entity/v1.0/track/:id   post    查询轨迹点
         *      url :id
         *   body: 
         *   {
         *       "startTime":0,
         *       "endTime":1555353909
         *   }
         *  */ 
        get_personnal_track_points: api_url('/entity/v1.0/track/'),
        
        /**
         * 总部修改成员剩余短信数量 put 
         * 参数 组织 id ，要增加的短信数量 num
         * /api/org/v1.0/sms/charge/${Id}/${num}
         *  */ 
        modify_org_sms_num: api_url('/org/v1.0/sms/charge/'),

        /**
         * 获取剩余短信数量 get 
         * 参数 组织 id
         * /api/org/v1.0/sms/num/{Id}
         *  */ 
        get_org_sms_num: api_url('/org/v1.0/sms/num/'),
        
        /**
         * 获取注册设备时的状态 get 
         * 参数 无
         *  */
        get_devices_regin_status: api_url('/device/v1.0/store/result'),

        /**
         * 删除分组监管规则 get 
         * api/entityGroup/v1.0/delete/{id} 
         * url参数 id
         *  */
        delete_entity_group_config: api_url('/entityGroup/v1.0/delete/'),
        
        /**
         * 查询系统日志 post 
         * api//org/v1.0/systemLog 
         * body参数 可选
         * {
         *  type: ‘登陆’   查询方式
         *  link: 20 机构类别
         *  matchType: ll eq 
         *  entrance: app
         *  startTime: 12312321 
         *  endTime: 123123123
         *  dimMatch: 'name' 模糊查询
         * }
         *  */
        post_system_logs: api_url('/org/v1.0/systemLog'),

        /**
         * 获取所有查询系统日志的类别 get 
         * api/org/v1.0/systemLogType 
         * url参数 无
         *  */
        get_query_logs_type: api_url('/org/v1.0/systemLogType'),

        /**
         * 查询当前机构名称是否被占用 post 
         * /api/commons/v1.0/validOrgName  
         * body {parentLink   string    父机构link,
         *   name     string   创建的机构名 }
         *  */
        check_has_same_org_name: api_url('/commons/v1.0/validOrgName'),

        /**
         * 查询当前用户名称是否被占用 post 
         * /api/commons/v1.0/validUserName  
         * body {
         *   name     string   创建的机构名 }
         *  */
        check_has_same_user_name: api_url('/commons/v1.0/validUserName'),

        /**
         * 查询当前实体的健康状态 get /api/entity/v1.0/current/health/{entityId}
         * url参数 id 实体的id
         *  /api/entity/v1.0/current/health/{entityId}  
         * 
         *  */
        get_entity_current_health: api_url('/entity/v1.0/current/health/'),

        /**
         * 获取所有告警类型的接口 get /api/alarm/v1.0/alarmTypes
         * 
         * 
         *  */
        get_alarm_types: api_url('/alarm/v1.0/alarmTypes'),

         /**
         * 修改设备ID /api/device/v1.0/updateDeviceModel/{deviceModelId}   post  
         *  body {
         *  ids: []
         * }
         * 
         *  */
        revise_device_type: api_url('/device/v1.0/updateDeviceModel/'),


        /**
         * 用户重置密码 /api/users/v1.0/password   post  
         *  body {
         *  password: '',
         * new_password: ''
         * }
         * 
         *  */
        reset_password_by_user: api_url('/users/v1.0/password'),

        /**
         * 短信是否共享 /api/org/v1.0/settings/shareSmsNum   post  
         *  body {
         *  orgLink: '',
         * isShare: bool
         * }
         * 
         *  */
        set_is_share_sms: api_url('/org/v1.0/settings/shareSmsNum'),

        /**
         * 刷新token /api/org/v1.0/settings/shareSmsNum   post  
         *  body {
         *  token
         * }
         * 
         *  */
        refresh_token: common_url('/auth/v1.0/refreshToken'),


        /**
         * 获取分组信息 /api/entityGroup/v1.0/summary/{orgId}    get 
         *  
         * 
         *  */
        get_org_groups_info: api_url('/entityGroup/v1.0/summary/'),

        /**
         * 获取设备制式 /api/device/v1.0/deviceModel/correspondStandard    get 
         *  
         * 
         *  */
        get_device_standard: api_url('/device/v1.0/deviceModel/correspondStandard'),

        /**
         * 修改设备remark /api/device/v1.0/updateDevice    post
         *  {"id":12345,                                  //设备ID
              "deviceExtension":{
              "remark":"aaaa"      //设备主机号
                   }
         * }
         * 
         *  */
        set_device_remark: api_url('/device/v1.0/updateDevice'),

        /**
         * 获取设备类型 /api/device/v1.0/getDeviceModel/{deviceId}    get
         *  
         * 
         *  */
        get_device_model_by_id: api_url('/device/v1.0/getDeviceModel/'),

        /**
         * 设置告警铃声响动类型 /api/users/v1.0/setRingTime/{type}   post    get
         *  
         * 
         *  */
        set_alarm_notice_type: api_url('/users/v1.0/setRingTime/'),


        /**
         * 广播消息 /api/notify/v1.0/notice/text     post body传参：
          *   {
          *  "content":"aaaaa",
          *  "entityIds": []
          *  }
         * 
         *  */
        broadcast_message: api_url('/notify/v1.0/notice/text'),

        /**
         * 查询广播消息列表 /api/notify/v1.0/notice/list     post body传参：
          *   {
          *  dimMatch: ''
          * minTime
          * maxTime
          *  }
         * 
         *  */
        query_broadcast_list: api_url('/notify/v1.0/notice/list'),

        /**
         * 查询某次广播消息结果 /api/notify/v1.0/notice/status/{groupIdentification}     get 
         * 
         *  */
        get_current_broadcast_byId: api_url('/notify/v1.0/notice/status/'),

        /**
         * 查询广播消息列表 /api/notify/v1.0/notice/retry     post body传参：
          *   [ids
          *  
         * 
         *  */
        resend_broadcast_message: api_url('/notify/v1.0/notice/retry'),

        // 创建子用户
        /**
         *  /api/users/v1.0/attache    post   body传参：
          *   { username, nickname, password, imageUrl, phone, orgid}
          *  
         * 
         *  */
        create_attache_user: api_url('/users/v1.0/attache'),

        // 删除用户
        /**
         *  /api/users/v1.0/attache/{userId}     delete   delete传参 用户id
          *  
         * 
         *  */
        delete_attache_user: api_url('/users/v1.0/attache/'),

        // 查询实体事件记录
        /**
         *  /api/entity/v1.0/summary/list      post    实体事件条件查询
          *  body传参：
            {
            dimMatch string  模糊查询  记录者 事件内容  人员名字
            title  string  事件title
            entityId long    实体Id
            minTime  long 开始时间
            maxTime  long  结束时间

            }
         * 
         *  */
        query_entity_logs_summary: api_url('/entity/v1.0/summary/list'),
        send_command: api_url('/entity/v1.0/sendCommand'),
        save_area: api_url('/area/v1.0/save'),
        query_area_list: api_url('/area/v1.0/list'),
        update_area: api_url('/area/v1.0/update'),
        delete_area: api_url('/area/v1.0/delete'),
        person_statistics: api_url('/area/v1.0/personStatistics'),

        statistics: api_url('/home/v1.0/visualDisplay'),
    }
}